import { render, staticRenderFns } from "./productfile.vue?vue&type=template&id=70c9150f&scoped=true&"
import script from "./productfile.vue?vue&type=script&lang=js&"
export * from "./productfile.vue?vue&type=script&lang=js&"
import style0 from "./productfile.vue?vue&type=style&index=0&id=70c9150f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9150f",
  null
  
)

export default component.exports